import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Step extends Vue {
  @Prop()
  public label!: string;
  @Prop()
  public stepNumber!: number;
  @Prop()
  public selected!: boolean;
  @Prop()
  public passed!: boolean;
  @Prop()
  public jumpable!: boolean;

  public onStepClicked() {
    this.$emit('update-selected-step-number', Number(this.stepNumber));
  }
}
